/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
"use strict";

const Hook = require("./Hook");
const HookCodeFactory = require("./HookCodeFactory");
class SyncWaterfallHookCodeFactory extends HookCodeFactory {
  content(_ref) {
    let onError = _ref.onError,
      onResult = _ref.onResult,
      resultReturns = _ref.resultReturns,
      rethrowIfPossible = _ref.rethrowIfPossible;
    return this.callTapsSeries({
      onError: (i, err) => onError(err),
      onResult: (i, result, next) => {
        let code = "";
        code += `if(${result} !== undefined) {\n`;
        code += `${this._args[0]} = ${result};\n`;
        code += `}\n`;
        code += next();
        return code;
      },
      onDone: () => onResult(this._args[0]),
      doneReturns: resultReturns,
      rethrowIfPossible
    });
  }
}
const factory = new SyncWaterfallHookCodeFactory();
class SyncWaterfallHook extends Hook {
  constructor(args) {
    super(args);
    if (args.length < 1) throw new Error("Waterfall hooks must have at least one argument");
  }
  tapAsync() {
    throw new Error("tapAsync is not supported on a SyncWaterfallHook");
  }
  tapPromise() {
    throw new Error("tapPromise is not supported on a SyncWaterfallHook");
  }
  compile(options) {
    factory.setup(this, options);
    return factory.create(options);
  }
}
module.exports = SyncWaterfallHook;